import {api} from "./api";

export const pricingApi = {
  getPricing: async (courseType, capacity, subject) => {
    return api.pricingSvcRequest('GET', `/pricing/prices?courseType=${courseType}&capacity=${capacity}&subject=${subject}`);
  }
};